(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-wb-ref]');
  if (!roots.length) return;
  roots.forEach(initRoot);

  function initRoot(root) {
    var kind = root.getAttribute('data-wb-ref');
    var src  = root.getAttribute('data-source');
    var grid = root.querySelector('[data-wb-ref-grid]');
    var emptyEl = root.querySelector('[data-wb-ref-empty]');
    var countEl = root.querySelector('[data-wb-ref-count]');
    var qInput  = root.querySelector('[data-wb-ref-q]');
    var clearBtn = root.querySelector('[data-wb-ref-clear]');
    var selects = root.querySelectorAll('[data-wb-ref-filter]');

    fetch(src, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (kind === 'zasshi' ? data.issues : data.volumes) || [];
        populateFilters(items);
        render();

        qInput.addEventListener('input', schedule);
        selects.forEach(function (s) { s.addEventListener('change', render); });
        clearBtn.addEventListener('click', function () {
          qInput.value = '';
          selects.forEach(function (s) { s.value = ''; });
          render();
        });

        function populateFilters(rows) {
          selects.forEach(function (sel) {
            var key = sel.getAttribute('data-wb-ref-filter');
            var seen = new Set();
            rows.forEach(function (r) {
              var v = r[key];
              if (v == null || v === '') return;
              seen.add(String(v));
            });
            var values = Array.from(seen).sort(function (a, b) {
              if (key === 'year') return Number(b) - Number(a);
              return a.localeCompare(b, undefined, { sensitivity: 'base' });
            });
            values.forEach(function (v) {
              var o = document.createElement('option');
              o.value = v;
              o.textContent = v;
              sel.appendChild(o);
            });
          });
        }

        function getFilters() {
          var f = {};
          selects.forEach(function (s) {
            var v = s.value;
            if (v) f[s.getAttribute('data-wb-ref-filter')] = v;
          });
          return f;
        }

        var t;
        function schedule() { clearTimeout(t); t = setTimeout(render, 80); }

        function render() {
          var q = (qInput.value || '').trim().toLowerCase();
          var f = getFilters();
          var hasFilters = q.length > 0 || Object.keys(f).length > 0;
          clearBtn.hidden = !hasFilters;

          var filtered = items.filter(function (it) {
            for (var k in f) {
              if (String(it[k] == null ? '' : it[k]) !== f[k]) return false;
            }
            if (!q) return true;
            return matchesQuery(it, q);
          });

          countEl.textContent = filtered.length + ' of ' + items.length;
          grid.innerHTML = '';
          if (!filtered.length) { emptyEl.hidden = false; return; }
          emptyEl.hidden = true;
          var frag = document.createDocumentFragment();
          filtered.forEach(function (it, idx) {
            frag.appendChild(buildCard(it, idx));
          });
          grid.appendChild(frag);
        }

        function matchesQuery(it, q) {
          var hay;
          if (kind === 'zasshi') {
            hay = [it.magazine, it.year, it.issue, it.month, it.notes, it.search_query];
            (it.events || []).forEach(function (e) {
              hay.push(e.type, e.subject, e.series, e.description);
            });
          } else {
            hay = [it.series, it.volume, it.language, it.english_title, it.publisher, it.year, it.isbn, it.notes, it.search_query];
          }
          return hay.some(function (v) {
            return v != null && String(v).toLowerCase().indexOf(q) !== -1;
          });
        }

        function buildCard(it, idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'wb-ref__card';
          btn.addEventListener('click', function () { openDetail(it); });

          var cover = document.createElement('div');
          cover.className = 'wb-ref__cover';
          if (it.cover_url) {
            var img = document.createElement('img');
            img.src = it.cover_url;
            img.alt = altText(it);
            img.loading = idx > 8 ? 'lazy' : 'eager';
            cover.appendChild(img);
          } else {
            cover.classList.add('wb-ref__cover--empty');
            cover.textContent = 'no cover';
          }
          btn.appendChild(cover);

          var meta = document.createElement('div');
          meta.className = 'wb-ref__meta';

          if (kind === 'zasshi') {
            var primary = (it.events || []).find(function (e) { return e.is_primary; }) || (it.events || [])[0];
            var pill = document.createElement('span');
            if (primary) {
              pill.className = 'wb-ref__pill';
              pill.textContent = formatEventTitle(primary);
            } else {
              pill.className = 'wb-ref__pill wb-ref__pill--empty';
              pill.textContent = '(no event)';
            }
            meta.appendChild(pill);

            var line = document.createElement('div');
            line.className = 'wb-ref__sub';
            line.textContent = zasshiIssueLine(it);
            meta.appendChild(line);

            var extra = (it.events || []).length - 1;
            if (extra > 0) {
              var ex = document.createElement('div');
              ex.className = 'wb-ref__extra';
              ex.textContent = '+ ' + extra + ' more event' + (extra === 1 ? '' : 's');
              meta.appendChild(ex);
            }
          } else {
            var title = document.createElement('div');
            title.className = 'wb-ref__title';
            title.textContent = it.series + ' v' + it.volume;
            meta.appendChild(title);

            var sub = document.createElement('div');
            sub.className = 'wb-ref__sub';
            sub.textContent = tankobonSubLine(it);
            meta.appendChild(sub);

            if (it.english_title && it.english_title !== it.series) {
              var en = document.createElement('div');
              en.className = 'wb-ref__sub';
              en.textContent = it.english_title;
              meta.appendChild(en);
            }
          }
          btn.appendChild(meta);
          return btn;
        }

        function altText(it) {
          if (kind === 'zasshi') return (it.magazine || '') + ' ' + (it.year || '') + ' #' + (it.issue || '');
          return (it.series || '') + ' v' + (it.volume || '');
        }
      })
      .catch(function (err) {
        console.error('reference-grid:', err);
        emptyEl.hidden = false;
        emptyEl.textContent = 'Could not load reference data.';
      });
  }

  function formatEventTitle(e) {
    var bits = [];
    if (e.subject) bits.push(e.subject);
    if (e.series && e.series !== e.subject) bits.push(e.series);
    var head = bits.join(' — ');
    if (e.type) {
      return head ? (head + ' · ' + e.type) : e.type;
    }
    return head || 'event';
  }

  function zasshiIssueLine(it) {
    var parts = [it.magazine];
    if (it.year) parts.push(it.year);
    if (it.issue) parts.push('#' + it.issue);
    if (it.month) parts.push(it.month);
    return parts.filter(Boolean).join(' · ');
  }

  function tankobonSubLine(it) {
    var parts = [];
    if (it.language) parts.push(it.language);
    if (it.publisher) parts.push(it.publisher);
    if (it.year) parts.push(it.year);
    return parts.join(' · ');
  }

  // ── Detail dialog ─────────────────────────────────────────────────
  var dialog;
  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'wb-ref__dialog';
    dialog.innerHTML =
      '<button type="button" class="wb-ref__dialog-close" aria-label="Close">×</button>' +
      '<div class="wb-ref__dialog-inner">' +
        '<div class="wb-ref__dialog-cover" data-cover></div>' +
        '<div class="wb-ref__dialog-body" data-body></div>' +
      '</div>';
    document.body.appendChild(dialog);
    dialog.querySelector('.wb-ref__dialog-close').addEventListener('click', function () {
      dialog.close();
    });
    dialog.addEventListener('click', function (e) {
      var rect = dialog.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
        dialog.close();
      }
    });
    return dialog;
  }

  function openDetail(it) {
    var d = ensureDialog();
    var coverEl = d.querySelector('[data-cover]');
    var bodyEl  = d.querySelector('[data-body]');
    coverEl.innerHTML = '';
    bodyEl.innerHTML  = '';

    if (it.cover_url) {
      var img = document.createElement('img');
      img.src = it.cover_url;
      img.alt = '';
      coverEl.appendChild(img);
    } else {
      coverEl.textContent = 'no cover';
      coverEl.style.color = 'rgba(var(--color-foreground), 0.5)';
    }

    if (it.events) {
      bodyEl.appendChild(renderZasshiBody(it));
    } else {
      bodyEl.appendChild(renderTankobonBody(it));
    }

    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
  }

  function renderZasshiBody(it) {
    var wrap = document.createElement('div');
    var h = document.createElement('h2');
    h.textContent = it.magazine + (it.issue ? ' #' + it.issue : '');
    wrap.appendChild(h);

    var sub = document.createElement('div');
    sub.className = 'wb-ref__sub';
    var subParts = [];
    if (it.year) subParts.push(it.year);
    if (it.month) subParts.push(it.month);
    sub.textContent = subParts.join(' · ');
    wrap.appendChild(sub);

    if (it.notes) {
      var n = document.createElement('div');
      n.className = 'wb-ref__notes';
      n.textContent = it.notes;
      wrap.appendChild(n);
    }

    if ((it.events || []).length) {
      var ul = document.createElement('ul');
      ul.className = 'wb-ref__events';
      it.events.forEach(function (e) {
        var li = document.createElement('li');
        li.className = 'wb-ref__event';
        var head = document.createElement('div');
        head.className = 'wb-ref__event-head';
        if (e.type) {
          var t = document.createElement('span');
          t.className = 'wb-ref__event-type' + (e.is_primary ? '' : ' wb-ref__event-type--secondary');
          t.textContent = e.type;
          head.appendChild(t);
        }
        if (e.subject) {
          var s = document.createElement('span');
          s.className = 'wb-ref__event-subject';
          s.textContent = e.subject;
          head.appendChild(s);
        }
        if (e.series) {
          var sr = document.createElement('span');
          sr.className = 'wb-ref__event-series';
          sr.textContent = e.series;
          head.appendChild(sr);
        }
        li.appendChild(head);
        if (e.description) {
          var d = document.createElement('div');
          d.className = 'wb-ref__event-desc';
          d.textContent = e.description;
          li.appendChild(d);
        }
        ul.appendChild(li);
      });
      wrap.appendChild(ul);
    }

    return wrap;
  }

  function renderTankobonBody(it) {
    var wrap = document.createElement('div');
    var h = document.createElement('h2');
    h.textContent = it.series + ' v' + it.volume;
    wrap.appendChild(h);

    var sub = document.createElement('div');
    sub.className = 'wb-ref__sub';
    sub.textContent = tankobonSubLine(it);
    wrap.appendChild(sub);

    var dl = document.createElement('dl');
    dl.className = 'wb-ref__detail-grid';
    var rows = [
      ['Language',      it.language],
      ['English title', it.english_title && it.english_title !== it.series ? it.english_title : ''],
      ['Publisher',     it.publisher],
      ['Year',          it.year],
      ['ISBN',          it.isbn],
    ];
    rows.forEach(function (r) {
      if (!r[1]) return;
      var dt = document.createElement('dt'); dt.textContent = r[0];
      var dd = document.createElement('dd'); dd.textContent = r[1];
      dl.appendChild(dt); dl.appendChild(dd);
    });
    wrap.appendChild(dl);

    if (it.notes) {
      var n = document.createElement('div');
      n.className = 'wb-ref__notes';
      n.textContent = it.notes;
      wrap.appendChild(n);
    }

    return wrap;
  }
})();
